import type { Dexie } from 'dexie'
import * as lodash from 'lodash'
import { timeout } from '../../../shared/lib/timeout.no-deps'

export async function IDB_chunkedPut<T>(table: Dexie.Table<T>, rows: T[], chunkSize = 10000) {
    const chunks = lodash.chunk(rows, chunkSize)

    for (const chunk of chunks) {
        await table.bulkPut(chunk)
        await timeout(100)
    }
}
